export default "__VITE_ASSET__fbe7b17e__"